// extracted by mini-css-extract-plugin
module.exports = {"Grid":"Grid_Grid__DvtLf","Grid_2":"Grid_Grid_2__2bE5V","Grid_3":"Grid_Grid_3__27ZNe","Grid_7":"Grid_Grid_7__QqFHd","GridGap":"Grid_GridGap__35kvf"};